/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solana_Multiply_Page_Meta_TitleInputs */

const en_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const de_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const pt_br2_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const tr_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const zh_cn2_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const zh_hk2_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const ko_kr2_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const ru_ru2_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

const es_419_solana_multiply_page_meta_title = /** @type {(inputs: Solana_Multiply_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solana Multiply (experimental) | Glider`)
};

/**
* | output |
* | --- |
* | "Solana Multiply (experimental) \| Glider" |
*
* @param {Solana_Multiply_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const solana_multiply_page_meta_title = /** @type {((inputs?: Solana_Multiply_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solana_Multiply_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solana_multiply_page_meta_title(inputs)
	if (locale === "de") return de_solana_multiply_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_solana_multiply_page_meta_title(inputs)
	if (locale === "tr") return tr_solana_multiply_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_solana_multiply_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_solana_multiply_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_solana_multiply_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_solana_multiply_page_meta_title(inputs)
	return es_419_solana_multiply_page_meta_title(inputs)
});